<template>
  <div class="tab-content">
    <div class="title-wrap">
      <div class="left">
        <span class="title">{{ cnt.title }}</span>
        <span class="sub-title">{{ cnt.subTitle }}</span>
      </div>
      <div class="right">
        <div v-if="cnt.status" class="status-text">
          <i class="el-icon-time"></i> 预计处理时间：30分钟内
        </div>
        <div class="fr1" v-else>
          <el-button type="danger" icon="el-icon-close" circle></el-button>
          维护
        </div>
      </div>
    </div>
    <div class="warning" v-if="cnt.tip != '' && cnt.tip != null">
      <p v-html="cnt.tip"></p>
    </div>

    <div class="input-section">
      <div class="input-header">
        <span class="label">素材ID列表</span>
        <span class="count" v-if="idCount > 0">已输入 {{ idCount }} 个ID</span>
      </div>
      <el-input
        type="textarea"
        class="textarea"
        v-model="cnt.label"
        @input="descInput"
        :placeholder="placeholder"
        :rows="6"
        :disabled="cnt.titleState == 'error' || isSearching"
      ></el-input>
      <p class="error" v-if="errorMsg">{{ errorMsg }}</p>
    </div>

    <div class="action-section">
      <el-button
        class="btn-submit"
        @click="submit"
        type="primary"
        icon="el-icon-search"
        :disabled="isSearching || !cnt.label"
        :loading="isSearching"
      >
        搜索预览
      </el-button>
    </div>
  </div>
</template>

<script>
import { message } from "@/utils/resetMessage";
export default {
  props: {
    tabContent: {
      type: Object,
      default() {
        return {
          title: "",
          subTitle: "",
          label: "",
        };
      },
    },
    isSearching: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      placeholder:
        "请输入素材ID编号，一个ID一行，支持以下格式：\n" +
        "- 纯数字ID（如：123456789）\n" +
        "- 完整网址（系统会自动提取ID）\n" +
        "最多支持50个ID",
      errorMsg: "",
      idCount: 0,
    };
  },
  computed: {
    cnt() {
      return this.tabContent;
    },
  },
  mounted() {
    this.cnt.label = "";
  },
  methods: {
    submit() {
      if (!this.cnt.label || this.cnt.label.trim() === "") {
        this.errorMsg = "请输入素材ID";
        return;
      }

      const lines = this.cnt.label.split(/\n/);
      if (lines.length > 50) {
        message.error({
          message: "每个工单最多提交50个素材ID",
          duration: 4000,
          offset: 80,
        });
        return;
      }

      this.errorMsg = "";
      const recNewArray = [];

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        if (line.length > 0) {
          // 解析ID
          const parsedId = this.parseMaterialId(line);
          if (parsedId && recNewArray.indexOf(parsedId) < 0) {
            recNewArray.push(parsedId);
          }
        }
      }

      if (recNewArray.length === 0) {
        this.errorMsg = "未解析到有效的素材ID";
        return;
      }

      // 触发搜索预览事件
      this.$emit("search", recNewArray);
    },
    // 解析素材ID
    parseMaterialId(input) {
      // 去除空格
      let id = input.replace(/\s/g, "");

      // 如果输入是URL，尝试提取ID
      if (id.startsWith("http://") || id.startsWith("https://")) {
        // 尝试从URL中提取ID
        const patterns = [
          /\/(\d+)\.htm/,      // freepik
          /image-\w+-(\d+)/,   // shutterstock
          /\/\d+\/[\w-]+-(\d+)/, // istockphoto
          /\?id=(\d+)/,        // 通用id参数
          /\/(\d+)(?:\?|$)/,   // 最后一个数字
        ];

        for (const pattern of patterns) {
          const match = id.match(pattern);
          if (match) {
            id = match[1];
            break;
          }
        }
      }

      // 检查是否包含前缀（如 ss-123456）
      if (id.includes("-")) {
        const parts = id.split("-");
        if (parts.length === 2 && /^\d+$/.test(parts[1])) {
          id = parts[1];
        }
      }

      // 验证ID格式
      if (/^\d{5,15}$/.test(id)) {
        return id;
      }

      // 特殊格式（如 hi22 开头）
      if (id.startsWith("hi22") && id.length > 10) {
        return id;
      }

      return null;
    },
    clearInput() {
      this.cnt.label = "";
      this.errorMsg = "";
      this.idCount = 0;
    },
    descInput() {
      if (this.cnt.label) {
        const lines = this.cnt.label.split(/\n/);
        let count = 0;
        for (const line of lines) {
          if (line.trim().length > 0) {
            count++;
          }
        }
        this.idCount = count;

        if (lines.length > 20) {
          message.error({
            message: "ID行数限制20个",
            duration: 4000,
            offset: 80,
          });
        }
      } else {
        this.idCount = 0;
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.tab-content {
  background-color: white;
  padding: 30px;

  .title-wrap {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      display: flex;
      align-items: center;

      .title {
        display: inline-block;
        font-size: 28px;
        color: #000;
        font-weight: bold;
      }

      .sub-title {
        margin-left: 15px;
        font-size: 14px;
        color: #666;
        padding: 4px 12px;
        background: #f0f7ff;
        border-radius: 4px;
      }
    }

    .right {
      .status-text {
        color: #0773fc;
        font-size: 14px;

        i {
          margin-right: 5px;
        }
      }

      .fr1 {
        margin-left: auto;
        color: #ea0615;
        margin-right: 30px;

        .iconfont {
          font-size: 20px;
        }
      }
    }
  }

  .warning {
    display: block;
    padding: 12px 16px;
    background-color: #fff6f7;
    border-radius: 4px;
    border-left: 5px solid #fe6c6f;
    margin: 20px 0;

    p {
      font-size: 14px;
      color: #5e6d82;
      line-height: 1.8em;
    }
  }

  .input-section {
    margin-bottom: 20px;

    .input-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .label {
        font-size: 14px;
        color: #333;
        font-weight: 500;
      }

      .count {
        font-size: 13px;
        color: #0773fc;
      }
    }

    .textarea {
      ::v-deep .el-textarea__inner {
        padding: 15px;
        font-size: 14px;
        line-height: 1.6;
      }
    }

    .error {
      margin-top: 8px;
      color: #f56c6c;
      font-size: 13px;
    }
  }

  .action-section {
    display: flex;
    gap: 15px;
    margin-bottom: 25px;

    .btn-submit {
      flex: 1;
      padding: 15px 20px;
      font-size: 16px;
    }

    .btn-clear {
      width: 120px;
      padding: 15px 20px;
      font-size: 16px;
    }
  }

  .tips-section {
    .tip-content {
      p {
        margin: 8px 0;
        font-size: 13px;
        color: #666;
        line-height: 1.6;
      }
    }
  }
}
</style>
